import { Block } from 'src/__generated__/graphqlTypes';

const extractTextFromRichText = (node: any): string => {
  if (!node) {
    return '';
  }

  if (node.nodeType === 'text') {
    return node.value || '';
  }

  if (!node.content) {
    return '';
  }

  const blockContainerTypes = ['document', 'unordered-list', 'ordered-list', 'list-item'];
  const separator = blockContainerTypes.includes(node.nodeType) ? ' ' : '';

  return node.content.map(extractTextFromRichText).join(separator);
};

export const buildFaqSchema = (items: Block[], pageUrl: string): Record<string, any> | null => {
  if (!items.length) {
    return null;
  }

  const mainEntity = items.reduce<Array<Record<string, any>>>((store, item) => {
    const name = extractTextFromRichText(item.richTitle?.json).trim();
    const text = extractTextFromRichText((item as any).content?.json).trim();

    if (name && text) {
      store.push({
        '@type': 'Question',
        name,
        acceptedAnswer: {
          '@type': 'Answer',
          text,
        },
      });
    }

    return store;
  }, []);

  if (!mainEntity.length) {
    return null;
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    '@id': `${pageUrl}#faq`,
    mainEntity,
  };
};
